import React, { ComponentType }  from 'react'
import styled from '@emotion/styled'
import {KenticoImage} from '@components/elements/index'
import mq from '@styles/mq'
import {Container} from 'semantic-ui-react'
import { H1 } from '@styles/Global.styles'

type BannerContainerProps = {
  top?: number
}

export const SmallBannerContainer : ComponentType<BannerContainerProps> = styled.div`
  ${mq({
    height:['89px','89px','89px']
  })}
  position: relative;
  background-color: black;
  top: ${(props: BannerContainerProps) => props.top}px;
  display: block;
  width:100%;
  z-index: 1;
  &::after{
    ${mq({
      marginTop: ['-89px','-89px','-89px'],
      height:['89px','89px','89px']
    })}
    display: block;
    position: relative;
    width: 100%;
    content: '';
  }
`;
export const BannerContainer : ComponentType<BannerContainerProps> = styled.div`
  ${mq({
    height:['620px','420px','720px']
  })}
  position: relative;
  top: ${(props: BannerContainerProps) => props.top}px;
  display: block;
  width:100%;
  z-index: 1;
  &::after{
    ${mq({
      marginTop: ['-620px','-420px','-720px'],
      height:['620px','420px','720px']
    })}
    display: block;
    position: relative;
    width: 100%;
    content: '';
  }
`;

export const StyledKenticoImage = styled(({...props}) => <KenticoImage {...props}/>)`
  width: 100%;
  height: 100%;
`;

export const BannerContent = styled(({textVerticalAlign,...props}) => <Container {...props}/>)`
  ${props => 
    props.textVerticalAlign === 'bottom' ? mq({marginTop: ['-93px','-67px','-100px'],marginBottom: ['46px','23px','38px']}) 
  : props.textVerticalAlign === 'middle' ? mq({marginTop: ['-317px','-230px','-390px'],marginBottom: ['273px','186px','328px']})
  : props.textVerticalAlign === 'top' ? mq({marginTop: ['-495px','-158px','-260px'],marginBottom: ['460px','114px','198px']})
  :  mq({marginTop: ['-317px','-230px','-390px'],marginBottom: ['273px','186px','328px']})};
  display:block;
  position: relative;
  z-index:100;
  text-transform: capitalize;
  color: white;
  font-weight: bold;
`
export const BannerResponsiveImagesContainer = styled.div`
    height: 100%;
    > div {
      height: 100%;
    }
`

export const BigBannerContainer : ComponentType<BannerContainerProps> = styled.div`
  ${mq({
    height:['400px','400px','700px']
  })}
  position: relative;
  top: ${(props: BannerContainerProps) => props.top}px;
  display: block;
  width:100%;
  z-index: 1;
  &::after{
    ${mq({
      marginTop: ['-400px','-400px','-700px'],
      height: ['400px','400px','700px']
    })}
    display: block;
    position: relative;
    width: 100%;
    content: '';
  }
`;


export const BigBannerContent = styled(Container)`
  ${mq({
    marginTop: ['-200px','-200px','-360px'],
    marginBottom: ['168px','156px','298px']
  })}
  display:block;
  position: relative;
  z-index:100;
  text-transform: capitalize;
  color: white;
  font-weight: bold;
`

export const SmallBannerContent = styled(Container)`
  ${mq({
    marginTop: ['-200px','-200px','-360px'],
    marginBottom: ['89px','156px','298px']
  })}
  display:block;
  position: relative;
  z-index:100;
  text-transform: capitalize;
  color: white;
  font-weight: bold;
`

export const BannerTitle = styled(H1)`
  text-transform: none;
`